import { jsx, Fragment } from 'react/jsx-runtime';
import { Suspense } from 'react';
import { useIsSSR } from './useIsSSR.mjs';

function ServerSideSuspense(props) {
  const isSSR = useIsSSR();
  return isSSR ? /* @__PURE__ */ jsx(Fragment, { children: props.fallback }) : /* @__PURE__ */ jsx(Suspense, { ...props });
}

export { ServerSideSuspense as default };
//# sourceMappingURL=index.mjs.map
